/*jshint esversion:6 */
import React from "react";
import ErrorLabel from './errorLabel';

class FloatInput extends React.Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            className: "",
            value: !props.defaultValue ? "" : props.defaultValue,
        };
    }
    handleChange(event) {
        if (!this.props.maxLength || (event.target.value.length <= this.props.maxLength)) {
            this.setState({
                value: event.target.value
            });
            if (event.target.value !== '') {
                this.setState({ className: 'on' });
            } else {
                this.setState({ className: '' });
            }

            this.props.onChange && this.props.onChange(event);
        }
    }

    handleBlur(event){
        if (!this.props.maxLength || (event.target.value.length <= this.props.maxLength)) {
            this.setState({
                value: event.target.value
            });
            if (event.target.value !== '') {
                this.setState({ className: 'on' });
            } else {
                this.setState({ className: '' });
            }

            this.props.onBlur && this.props.onBlur(event);
        }
    }
    render() {
        let inputProps = Object.assign({}, this.props);
        delete inputProps.showError;
        delete inputProps.errorMessage;
        return (
            <div className="float__input form-group">
                <input
                    defaultValue={this.props.defaultValue}
                    name={this.props['data-safe'] ? new Date().getTime() : this.props.name}
                    id={this.props.id}
                    className={`form-control float_input ${this.props.showError ? 'error' : ''} ${this.props.className}`}
                    placeholder={this.props.placeholder}
                    onChange={this.handleChange.bind(this)}
                    onBlur={this.handleBlur.bind(this)}
                    autoComplete={this.props.autoComplete}
                    {...inputProps} />
                    <ErrorLabel message={this.props.showError ? this.props.errorMessage :  ""}/>
            </div>
        )
    }
}
export default FloatInput;


// WEBPACK FOOTER //
// ./src/components/common/floatInput.js